<template>
  <div>
    <!-- <sidebar-item
      text="Dashboard"
      :to="{ name: HOME_ROUTE_NAME }"
    >
      <template #icon>
        <use xlink:href="#icon-dashboard" />
      </template>
    </sidebar-item> -->
    <sidebar-item
      text="Gerar listas e gabaritos"
      :to="{ name: HOME_ROUTE_NAME }"
    >
      <template #icon>
        <use xlink:href="#icon-paper" />
      </template>
    </sidebar-item>


    <!-- <dropdown-item
      v-if="authUser.is_manager"
      title="Gerenciar"
      :items="MANAGE_MENUS"
    >
      <template #icon>
        <span class="sidebar-link__icon-dropwdown">
          <svg xmlns="http://www.w3.org/2000/svg">
            <use xlink:href="#icon-paper" />
          </svg>
        </span>
      </template>
    </dropdown-item> -->
  </div>
</template>
<script>
import SidebarItem from "./SidebarItem";
import DropdownItem from "./DropDownItem";
import {
  HOME_ROUTE_NAME,
  BOOKS_AND_CARDS_ROUTE_NAME,
} from '@/school/constants/routes';

import { mapGetters } from 'vuex';

export default {
  components: {
    SidebarItem,
    DropdownItem
  },
  data() {
    return {
      HOME_ROUTE_NAME,
      BOOKS_AND_CARDS_ROUTE_NAME,
    }
  },
  computed: {
    ...mapGetters(['authUser']),
  },
}
</script>
